// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyAccountScreen-module__font-s-10___e57Xw {
  font-size: 10px !important;
}

.MyAccountScreen-module__font-s-12___n07_W {
  font-size: 12px !important;
}

.MyAccountScreen-module__font-s-13___wQMh1 {
  font-size: 13px !important;
}

.MyAccountScreen-module__font-s-14___vnw0k {
  font-size: 14px !important;
}

.MyAccountScreen-module__font-s-15___MqUwT {
  font-size: 15px !important;
}

.MyAccountScreen-module__font-s-16___bMsUS {
  font-size: 16px !important;
}

.MyAccountScreen-module__font-s-18___noUzc {
  font-size: 18px !important;
}

.MyAccountScreen-module__font-s-20___M5YYJ {
  font-size: 20px !important;
}

.MyAccountScreen-module__font-s-22___yikpd {
  font-size: 22px !important;
}

.MyAccountScreen-module__font-s-28___JPQVp {
  font-size: 28px !important;
}

.MyAccountScreen-module__font-w-400___Mrewc {
  font-weight: 400 !important;
}

.MyAccountScreen-module__font-w-500___CaQoc {
  font-weight: 500 !important;
}

.MyAccountScreen-module__font-w-600___aYZPn {
  font-weight: 600 !important;
}

.MyAccountScreen-module__font-w-700___C1uZA {
  font-weight: 700 !important;
}

.MyAccountScreen-module__p-5___putbv {
  padding: 5px !important;
}

.MyAccountScreen-module__p-12___XjSn9 {
  padding: 12px !important;
}

.MyAccountScreen-module__p-16___m9Olg {
  padding: 16px !important;
}

.MyAccountScreen-module__p-30___KWzxC {
  padding: 30px !important;
}

.MyAccountScreen-module__p-b-0___Pj4W1 {
  padding-bottom: 0 !important;
}

.MyAccountScreen-module__p-b-5___Dtqe1 {
  padding-bottom: 5px !important;
}

.MyAccountScreen-module__p-b-10___py6I2 {
  padding-bottom: 10px !important;
}

.MyAccountScreen-module__p-b-12___SYumO {
  padding-bottom: 12px !important;
}

.MyAccountScreen-module__p-b-16___olb5I {
  padding-bottom: 16px !important;
}

.MyAccountScreen-module__p-b-18___iDVtf {
  padding-bottom: 18px !important;
}

.MyAccountScreen-module__p-b-20___TkPyP {
  padding-bottom: 20px !important;
}

.MyAccountScreen-module__p-b-25___dLh0Y {
  padding-bottom: 25px !important;
}

.MyAccountScreen-module__p-b-30___OS7di {
  padding-bottom: 30px !important;
}

.MyAccountScreen-module__p-b-50___hUr01 {
  padding-bottom: 50px !important;
}

.MyAccountScreen-module__p-t-0___LvDoq {
  padding-top: 0 !important;
}

.MyAccountScreen-module__p-t-12___CK0HK {
  padding-top: 12px !important;
}

.MyAccountScreen-module__p-t-16___cR3y0 {
  padding-top: 16px !important;
}

.MyAccountScreen-module__p-t-18___JyJBJ {
  padding-top: 18px !important;
}

.MyAccountScreen-module__p-t-20___VF_Be {
  padding-top: 20px !important;
}

.MyAccountScreen-module__p-t-30___kBspe {
  padding-top: 30px !important;
}

.MyAccountScreen-module__p-t-40___PxL9v {
  padding-top: 40px !important;
}

.MyAccountScreen-module__p-t-50___MfYz2 {
  padding-top: 50px !important;
}

.MyAccountScreen-module__p-l-20___urPOp {
  padding-left: 20px !important;
}

.MyAccountScreen-module__p-l-30___po09O {
  padding-left: 30px !important;
}

.MyAccountScreen-module__p-l-40___ivUgP {
  padding-left: 40px !important;
}

.MyAccountScreen-module__p-r-16___fbSd4 {
  padding-right: 16px !important;
}

.MyAccountScreen-module__p-r-20___T1Yxw {
  padding-right: 20px !important;
}

.MyAccountScreen-module__p-r-30___rO9_V {
  padding-right: 30px !important;
}

.MyAccountScreen-module__p-r-50___gJC2N {
  padding-right: 50px !important;
}

.MyAccountScreen-module__p-r-60___EtoSk {
  padding-right: 60px !important;
}

.MyAccountScreen-module__m-b-1___o51iG {
  margin-bottom: 1px !important;
}

.MyAccountScreen-module__m-b-2___h3dBK {
  margin-bottom: 2px !important;
}

.MyAccountScreen-module__m-b-6___q1qwW {
  margin-bottom: 6px !important;
}

.MyAccountScreen-module__m-b-8___gxPLH {
  margin-bottom: 8px !important;
}

.MyAccountScreen-module__m-b-10___a7IBA {
  margin-bottom: 10px !important;
}

.MyAccountScreen-module__m-b-14___iETFG {
  margin-bottom: 14px !important;
}

.MyAccountScreen-module__m-b-16___sdBHY {
  margin-bottom: 16px !important;
}

.MyAccountScreen-module__m-b-20___Js_Vu {
  margin-bottom: 20px !important;
}

.MyAccountScreen-module__m-b-22___BaBX1 {
  margin-bottom: 22px !important;
}

.MyAccountScreen-module__m-b-24___dqN68 {
  margin-bottom: 24px !important;
}

.MyAccountScreen-module__m-b-30___LWbyp {
  margin-bottom: 30px !important;
}

.MyAccountScreen-module__m-b-32___VL1bW {
  margin-bottom: 32px !important;
}

.MyAccountScreen-module__m-b-40___mvmwm {
  margin-bottom: 40px !important;
}

.MyAccountScreen-module__m-t-2___kbwgi {
  margin-top: 2px !important;
}

.MyAccountScreen-module__m-t-3___MIZ77 {
  margin-top: 3px !important;
}

.MyAccountScreen-module__m-t-4___f1tq5 {
  margin-top: 4px !important;
}

.MyAccountScreen-module__m-t-5___iLSjX {
  margin-top: 5px !important;
}

.MyAccountScreen-module__m-t-8___zn8k2 {
  margin-top: 8px !important;
}

.MyAccountScreen-module__m-t-10___TBwfq {
  margin-top: 10px !important;
}

.MyAccountScreen-module__m-t-15___jiz24 {
  margin-top: 15px !important;
}

.MyAccountScreen-module__m-t-16___aTcMS {
  margin-top: 16px !important;
}

.MyAccountScreen-module__m-t-20___twwZQ {
  margin-top: 20px !important;
}

.MyAccountScreen-module__m-t-22___OpMJO {
  margin-top: 22px !important;
}

.MyAccountScreen-module__m-t-30___TCkkB {
  margin-top: 30px !important;
}

.MyAccountScreen-module__m-t-32___p7kRj {
  margin-top: 32px !important;
}

.MyAccountScreen-module__m-l-auto___PDeQC {
  margin-left: auto !important;
}

.MyAccountScreen-module__m-l-4___AOXSl {
  margin-left: 4px !important;
}

.MyAccountScreen-module__m-l-5___ak55K {
  margin-left: 5px !important;
}

.MyAccountScreen-module__m-l-6___spO8U {
  margin-left: 6px !important;
}

.MyAccountScreen-module__m-l-8___Cbl7O {
  margin-left: 8px !important;
}

.MyAccountScreen-module__m-l-10___teyV7 {
  margin-left: 10px !important;
}

.MyAccountScreen-module__m-l-16___USWOR {
  margin-left: 16px !important;
}

.MyAccountScreen-module__m-l-20___WO_Z_ {
  margin-left: 20px !important;
}

.MyAccountScreen-module__m-l-24___NJmHn {
  margin-left: 24px !important;
}

.MyAccountScreen-module__m-l-30___vYaKY {
  margin-left: 30px !important;
}

.MyAccountScreen-module__m-l-35___ZCwo5 {
  margin-left: 35px !important;
}

.MyAccountScreen-module__m-l-40___lz5TM {
  margin-left: 40px !important;
}

.MyAccountScreen-module__m-r-8___bHc9F {
  margin-right: 8px !important;
}

.MyAccountScreen-module__m-r-10___L_ebq {
  margin-right: 10px !important;
}

.MyAccountScreen-module__m-r-16___nLq0u {
  margin-right: 16px !important;
}

.MyAccountScreen-module__m-r-20___XXE2Z {
  margin-right: 20px !important;
}

.MyAccountScreen-module__m-r-24___kHipA {
  margin-right: 24px !important;
}

.MyAccountScreen-module__m-r-30___RiT3I {
  margin-right: 30px !important;
}

.MyAccountScreen-module__m-r-40___kNcUQ {
  margin-right: 40px !important;
}

.MyAccountScreen-module__border-r-3___YZxQ4 {
  border-radius: 3px !important;
}

.MyAccountScreen-module__border-r-4___wWEd_ {
  border-radius: 4px !important;
}

.MyAccountScreen-module__border-r-6___bReeU {
  border-radius: 6px !important;
}

.MyAccountScreen-module__border-r-10___QDB4j {
  border-radius: 10px !important;
}

.MyAccountScreen-module__border-r-12___jrgwH {
  border-radius: 12px !important;
}

.MyAccountScreen-module__border-r-16___g24P_ {
  border-radius: 16px !important;
}

.MyAccountScreen-module__border-r-50___UPqTG {
  border-radius: 50% !important;
}

.MyAccountScreen-module__primary-border___NaUoj {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.MyAccountScreen-module__primary-border-b___lavBJ {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.MyAccountScreen-module__primary-border-t___JZ9mq {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.MyAccountScreen-module__primary-border-l___waar0 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.MyAccountScreen-module__primary-border-r___RzZjy {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.MyAccountScreen-module__secondary-border___cNEnL {
  border: 1px solid #637768;
}

.MyAccountScreen-module__secondary-border-b___jjlZE {
  border-bottom: 1px solid #637768;
}

.MyAccountScreen-module__secondary-border-t___xlRj_ {
  border-top: 1px solid #637768;
}

.MyAccountScreen-module__secondary-border-l____6LlD {
  border-left: 1px solid #637768;
}

.MyAccountScreen-module__secondary-border-r___p8kDd {
  border-right: 1px solid #637768;
}

.MyAccountScreen-module__gap-0___szrSO {
  gap: 0 !important;
}

.MyAccountScreen-module__gap-2___O6PDA {
  gap: 2px !important;
}

.MyAccountScreen-module__gap-4___b7HNY {
  gap: 4px !important;
}

.MyAccountScreen-module__gap-5___tvG3M {
  gap: 5px !important;
}

.MyAccountScreen-module__gap-6___lJK4x {
  gap: 6px !important;
}

.MyAccountScreen-module__gap-8___hyu3a {
  gap: 8px !important;
}

.MyAccountScreen-module__gap-10___t43OX {
  gap: 10px !important;
}

.MyAccountScreen-module__gap-12___pai6V {
  gap: 12px !important;
}

.MyAccountScreen-module__gap-14___RkvmK {
  gap: 14px !important;
}

.MyAccountScreen-module__gap-16___nldEN {
  gap: 16px !important;
}

.MyAccountScreen-module__gap-18___T0LPJ {
  gap: 18px !important;
}

.MyAccountScreen-module__gap-20___zCSX4 {
  gap: 20px !important;
}

.MyAccountScreen-module__gap-24___goIVp {
  gap: 24px !important;
}

.MyAccountScreen-module__gap-26___MB0GJ {
  gap: 26px !important;
}

.MyAccountScreen-module__gap-30___TSt_r {
  gap: 30px !important;
}

.MyAccountScreen-module__gap-32___HT5t_ {
  gap: 32px !important;
}

.MyAccountScreen-module__gap-40___Ftnqu {
  gap: 40px !important;
}

.MyAccountScreen-module__gap-50___SkUgL {
  gap: 50px !important;
}

.MyAccountScreen-module__flex-1___i1lpm {
  flex: 1;
}

.MyAccountScreen-module__flex-none___c9cQC {
  flex: none !important;
}

.MyAccountScreen-module__flex-column___fb7YC {
  display: flex;
  flex-direction: column !important;
}

.MyAccountScreen-module__flex-row___Qzzre {
  display: flex;
  flex-direction: row !important;
}

.MyAccountScreen-module__vertically-centered___z1_Zf {
  display: flex;
  align-items: center !important;
}

.MyAccountScreen-module__horizontally-centered___MgIdt {
  display: flex;
  justify-content: center !important;
}

.MyAccountScreen-module__horizontally-end___uexvu {
  display: flex;
  justify-content: end !important;
}

.MyAccountScreen-module__vertically-start___hNZX1 {
  display: flex;
  align-items: start !important;
}

.MyAccountScreen-module__space-between___BsOYl {
  display: flex;
  justify-content: space-between !important;
}

.MyAccountScreen-module__flex-wrap___XYAaM {
  flex-wrap: wrap !important;
}

.MyAccountScreen-module__height-100___xiHXx {
  height: 100%;
}

.MyAccountScreen-module__width-50____D7Mn {
  width: 50% !important;
}

.MyAccountScreen-module__width-100___u7jPH {
  width: 100%;
}

.MyAccountScreen-module__cursor-pointer___K1QBq {
  cursor: pointer;
}

.MyAccountScreen-module__cursor-not-allowed___e_3hU {
  cursor: not-allowed !important;
}

.MyAccountScreen-module__absolute-centered___Rkj2B {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.MyAccountScreen-module__absolute___qV_V5 {
  position: absolute;
}

.MyAccountScreen-module__relative___wr0LP {
  position: relative;
}

.MyAccountScreen-module__fixed___QM6TY {
  position: fixed;
}

.MyAccountScreen-module__visible___zL8JQ {
  opacity: 1;
}

.MyAccountScreen-module__invisible___vE7ll {
  opacity: 0;
}

.MyAccountScreen-module__col-90___RcRTK {
  width: 90% !important;
}

.MyAccountScreen-module__col-auto___XOULT {
  width: auto !important;
}

.MyAccountScreen-module__medical-tabs___P3rNr {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.MyAccountScreen-module__medical-table-new___JGrmN {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MyAccountScreen-module__medical-table-new___JGrmN:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MyAccountScreen-module__medical-table-new___JGrmN::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MyAccountScreen-module__medical-table-new___JGrmN::-webkit-scrollbar-track {
  display: none;
}
.MyAccountScreen-module__medical-table-new___JGrmN.MyAccountScreen-module__no-pagination___NmAou {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.MyAccountScreen-module__medical-table-new___JGrmN.MyAccountScreen-module__no-pagination___NmAou:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.MyAccountScreen-module__medical-table-new___JGrmN.MyAccountScreen-module__no-pagination___NmAou::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.MyAccountScreen-module__medical-table-new___JGrmN.MyAccountScreen-module__no-pagination___NmAou::-webkit-scrollbar-track {
  display: none;
}

.MyAccountScreen-module__medical-table-empty___pKzyf {
  padding: 14px 40px !important;
}

.MyAccountScreen-module__icon-btn___oJKuv {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.MyAccountScreen-module__search-icon___hD8_c {
  width: 24px;
  height: 24px;
  align-self: center;
}

.MyAccountScreen-module__disable-select___usiSx {
  user-select: none;
}

.MyAccountScreen-module__break-word___HsEwK {
  word-break: break-word;
}

.MyAccountScreen-module__popup-clear-btn___aIez2 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.MyAccountScreen-module__scroll-m-b-20___YqDgC {
  scroll-margin-bottom: 20px;
}

.MyAccountScreen-module__container___pKKfd {
  flex: 1;
  overflow-y: auto;
  height: calc(100vh - var(--top-navigation) - 62px);
  width: 70%;
}
.MyAccountScreen-module__container___pKKfd .MyAccountScreen-module__header____uJgU {
  margin-left: 2vw;
}
.MyAccountScreen-module__container___pKKfd .MyAccountScreen-module__header____uJgU .MyAccountScreen-module__title___cpShq {
  font-family: var(--font-family);
  font-weight: 500;
  font-size: 1rem;
  margin: 2em 0 1em 0;
}
.MyAccountScreen-module__container___pKKfd .MyAccountScreen-module__header____uJgU .MyAccountScreen-module__subtitle___CJUXR {
  font-family: var(--font-family);
  font-weight: 400;
  font-size: 0.7rem;
  color: #a3a3a3;
}
.MyAccountScreen-module__container___pKKfd .MyAccountScreen-module__header____uJgU .MyAccountScreen-module__avatar___u297X {
  width: 125px;
  height: 125px;
  margin: 0.5em 0 1em 0;
}
.MyAccountScreen-module__container___pKKfd .MyAccountScreen-module__inputRow___XJZPg {
  display: flex;
  flex-direction: row;
  width: 100%;
}
.MyAccountScreen-module__container___pKKfd .MyAccountScreen-module__input___xUe1T {
  display: flex;
  flex: 1;
  padding: 2vh 2vw;
}
.MyAccountScreen-module__container___pKKfd .MyAccountScreen-module__item___BN4rD {
  display: flex;
  flex: 1;
}
.MyAccountScreen-module__container___pKKfd .MyAccountScreen-module__titleContainer___n3vv2 {
  padding: 0 20px;
}
.MyAccountScreen-module__container___pKKfd .MyAccountScreen-module__title___cpShq {
  font-family: var(--font-family);
  font-weight: 700;
  font-size: 1rem;
}
.MyAccountScreen-module__container___pKKfd .MyAccountScreen-module__button___uTxrW {
  width: 12rem;
  margin-left: 2vw;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/screens/MyAccountScreen/MyAccountScreen.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss","webpack://./../common/src/styles/global/_weights.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,OAAA;EACA,gBAAA;EACA,kDAAA;EACA,UAAA;AA8pBF;AA5pBE;EACE,gBAAA;AA8pBJ;AA5pBI;EEeF,+BApBO;EAqBP,gBCxBO;EDyBP,eAAA;EFfI,mBAAA;AAgqBN;AA7pBI;EEUF,+BApBO;EAqBP,gBAFmD;EAGnD,iBAAA;EFVI,cAAA;AAiqBN;AA9pBI;EACE,YAAA;EACA,aAAA;EACA,qBAAA;AAgqBN;AA5pBE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AA8pBJ;AA3pBE;EACE,aAAA;EACA,OAAA;EACA,gBAAA;AA6pBJ;AA1pBE;EACE,aAAA;EACA,OAAA;AA4pBJ;AAzpBE;EACE,eAAA;AA2pBJ;AAxpBE;EEvBA,+BApBO;EAqBP,gBCtBK;EDuBL,eAAA;AFkrBF;AAzpBE;EACE,YAAA;EACA,gBAAA;AA2pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  flex: 1;\n  overflow-y: auto;\n  height: calc(100vh - var(--top-navigation) - #{$settings-header});\n  width: 70%;\n\n  .header {\n    margin-left: 2vw;\n\n    .title {\n      @include get-font($roboto, $medium, medium);\n      margin: 2em 0 1em 0;\n    }\n\n    .subtitle {\n      @include get-font($font-size: xx-small);\n      color: get-color(gray, medium-dark);\n    }\n\n    .avatar {\n      width: 125px;\n      height: 125px;\n      margin: 0.5em 0 1em 0;\n    }\n  }\n\n  .inputRow {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n  }\n\n  .input {\n    display: flex;\n    flex: 1;\n    padding: 2vh 2vw;\n  }\n\n  .item {\n    display: flex;\n    flex: 1;\n  }\n\n  .titleContainer {\n    padding: 0 20px;\n  }\n\n  .title {\n    @include get-font($roboto, $bold, medium);\n  }\n\n  .button {\n    width: 12rem;\n    margin-left: 2vw;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n","$extra-light: 200;\n$light: 300;\n$regular: 400;\n$medium: 500;\n$semi-bold: 600;\n$bold: 700;\n$heavy: 900;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `MyAccountScreen-module__font-s-10___e57Xw`,
	"fontS12": `MyAccountScreen-module__font-s-12___n07_W`,
	"fontS13": `MyAccountScreen-module__font-s-13___wQMh1`,
	"fontS14": `MyAccountScreen-module__font-s-14___vnw0k`,
	"fontS15": `MyAccountScreen-module__font-s-15___MqUwT`,
	"fontS16": `MyAccountScreen-module__font-s-16___bMsUS`,
	"fontS18": `MyAccountScreen-module__font-s-18___noUzc`,
	"fontS20": `MyAccountScreen-module__font-s-20___M5YYJ`,
	"fontS22": `MyAccountScreen-module__font-s-22___yikpd`,
	"fontS28": `MyAccountScreen-module__font-s-28___JPQVp`,
	"fontW400": `MyAccountScreen-module__font-w-400___Mrewc`,
	"fontW500": `MyAccountScreen-module__font-w-500___CaQoc`,
	"fontW600": `MyAccountScreen-module__font-w-600___aYZPn`,
	"fontW700": `MyAccountScreen-module__font-w-700___C1uZA`,
	"p5": `MyAccountScreen-module__p-5___putbv`,
	"p12": `MyAccountScreen-module__p-12___XjSn9`,
	"p16": `MyAccountScreen-module__p-16___m9Olg`,
	"p30": `MyAccountScreen-module__p-30___KWzxC`,
	"pB0": `MyAccountScreen-module__p-b-0___Pj4W1`,
	"pB5": `MyAccountScreen-module__p-b-5___Dtqe1`,
	"pB10": `MyAccountScreen-module__p-b-10___py6I2`,
	"pB12": `MyAccountScreen-module__p-b-12___SYumO`,
	"pB16": `MyAccountScreen-module__p-b-16___olb5I`,
	"pB18": `MyAccountScreen-module__p-b-18___iDVtf`,
	"pB20": `MyAccountScreen-module__p-b-20___TkPyP`,
	"pB25": `MyAccountScreen-module__p-b-25___dLh0Y`,
	"pB30": `MyAccountScreen-module__p-b-30___OS7di`,
	"pB50": `MyAccountScreen-module__p-b-50___hUr01`,
	"pT0": `MyAccountScreen-module__p-t-0___LvDoq`,
	"pT12": `MyAccountScreen-module__p-t-12___CK0HK`,
	"pT16": `MyAccountScreen-module__p-t-16___cR3y0`,
	"pT18": `MyAccountScreen-module__p-t-18___JyJBJ`,
	"pT20": `MyAccountScreen-module__p-t-20___VF_Be`,
	"pT30": `MyAccountScreen-module__p-t-30___kBspe`,
	"pT40": `MyAccountScreen-module__p-t-40___PxL9v`,
	"pT50": `MyAccountScreen-module__p-t-50___MfYz2`,
	"pL20": `MyAccountScreen-module__p-l-20___urPOp`,
	"pL30": `MyAccountScreen-module__p-l-30___po09O`,
	"pL40": `MyAccountScreen-module__p-l-40___ivUgP`,
	"pR16": `MyAccountScreen-module__p-r-16___fbSd4`,
	"pR20": `MyAccountScreen-module__p-r-20___T1Yxw`,
	"pR30": `MyAccountScreen-module__p-r-30___rO9_V`,
	"pR50": `MyAccountScreen-module__p-r-50___gJC2N`,
	"pR60": `MyAccountScreen-module__p-r-60___EtoSk`,
	"mB1": `MyAccountScreen-module__m-b-1___o51iG`,
	"mB2": `MyAccountScreen-module__m-b-2___h3dBK`,
	"mB6": `MyAccountScreen-module__m-b-6___q1qwW`,
	"mB8": `MyAccountScreen-module__m-b-8___gxPLH`,
	"mB10": `MyAccountScreen-module__m-b-10___a7IBA`,
	"mB14": `MyAccountScreen-module__m-b-14___iETFG`,
	"mB16": `MyAccountScreen-module__m-b-16___sdBHY`,
	"mB20": `MyAccountScreen-module__m-b-20___Js_Vu`,
	"mB22": `MyAccountScreen-module__m-b-22___BaBX1`,
	"mB24": `MyAccountScreen-module__m-b-24___dqN68`,
	"mB30": `MyAccountScreen-module__m-b-30___LWbyp`,
	"mB32": `MyAccountScreen-module__m-b-32___VL1bW`,
	"mB40": `MyAccountScreen-module__m-b-40___mvmwm`,
	"mT2": `MyAccountScreen-module__m-t-2___kbwgi`,
	"mT3": `MyAccountScreen-module__m-t-3___MIZ77`,
	"mT4": `MyAccountScreen-module__m-t-4___f1tq5`,
	"mT5": `MyAccountScreen-module__m-t-5___iLSjX`,
	"mT8": `MyAccountScreen-module__m-t-8___zn8k2`,
	"mT10": `MyAccountScreen-module__m-t-10___TBwfq`,
	"mT15": `MyAccountScreen-module__m-t-15___jiz24`,
	"mT16": `MyAccountScreen-module__m-t-16___aTcMS`,
	"mT20": `MyAccountScreen-module__m-t-20___twwZQ`,
	"mT22": `MyAccountScreen-module__m-t-22___OpMJO`,
	"mT30": `MyAccountScreen-module__m-t-30___TCkkB`,
	"mT32": `MyAccountScreen-module__m-t-32___p7kRj`,
	"mLAuto": `MyAccountScreen-module__m-l-auto___PDeQC`,
	"mL4": `MyAccountScreen-module__m-l-4___AOXSl`,
	"mL5": `MyAccountScreen-module__m-l-5___ak55K`,
	"mL6": `MyAccountScreen-module__m-l-6___spO8U`,
	"mL8": `MyAccountScreen-module__m-l-8___Cbl7O`,
	"mL10": `MyAccountScreen-module__m-l-10___teyV7`,
	"mL16": `MyAccountScreen-module__m-l-16___USWOR`,
	"mL20": `MyAccountScreen-module__m-l-20___WO_Z_`,
	"mL24": `MyAccountScreen-module__m-l-24___NJmHn`,
	"mL30": `MyAccountScreen-module__m-l-30___vYaKY`,
	"mL35": `MyAccountScreen-module__m-l-35___ZCwo5`,
	"mL40": `MyAccountScreen-module__m-l-40___lz5TM`,
	"mR8": `MyAccountScreen-module__m-r-8___bHc9F`,
	"mR10": `MyAccountScreen-module__m-r-10___L_ebq`,
	"mR16": `MyAccountScreen-module__m-r-16___nLq0u`,
	"mR20": `MyAccountScreen-module__m-r-20___XXE2Z`,
	"mR24": `MyAccountScreen-module__m-r-24___kHipA`,
	"mR30": `MyAccountScreen-module__m-r-30___RiT3I`,
	"mR40": `MyAccountScreen-module__m-r-40___kNcUQ`,
	"borderR3": `MyAccountScreen-module__border-r-3___YZxQ4`,
	"borderR4": `MyAccountScreen-module__border-r-4___wWEd_`,
	"borderR6": `MyAccountScreen-module__border-r-6___bReeU`,
	"borderR10": `MyAccountScreen-module__border-r-10___QDB4j`,
	"borderR12": `MyAccountScreen-module__border-r-12___jrgwH`,
	"borderR16": `MyAccountScreen-module__border-r-16___g24P_`,
	"borderR50": `MyAccountScreen-module__border-r-50___UPqTG`,
	"primaryBorder": `MyAccountScreen-module__primary-border___NaUoj`,
	"primaryBorderB": `MyAccountScreen-module__primary-border-b___lavBJ`,
	"primaryBorderT": `MyAccountScreen-module__primary-border-t___JZ9mq`,
	"primaryBorderL": `MyAccountScreen-module__primary-border-l___waar0`,
	"primaryBorderR": `MyAccountScreen-module__primary-border-r___RzZjy`,
	"secondaryBorder": `MyAccountScreen-module__secondary-border___cNEnL`,
	"secondaryBorderB": `MyAccountScreen-module__secondary-border-b___jjlZE`,
	"secondaryBorderT": `MyAccountScreen-module__secondary-border-t___xlRj_`,
	"secondaryBorderL": `MyAccountScreen-module__secondary-border-l____6LlD`,
	"secondaryBorderR": `MyAccountScreen-module__secondary-border-r___p8kDd`,
	"gap0": `MyAccountScreen-module__gap-0___szrSO`,
	"gap2": `MyAccountScreen-module__gap-2___O6PDA`,
	"gap4": `MyAccountScreen-module__gap-4___b7HNY`,
	"gap5": `MyAccountScreen-module__gap-5___tvG3M`,
	"gap6": `MyAccountScreen-module__gap-6___lJK4x`,
	"gap8": `MyAccountScreen-module__gap-8___hyu3a`,
	"gap10": `MyAccountScreen-module__gap-10___t43OX`,
	"gap12": `MyAccountScreen-module__gap-12___pai6V`,
	"gap14": `MyAccountScreen-module__gap-14___RkvmK`,
	"gap16": `MyAccountScreen-module__gap-16___nldEN`,
	"gap18": `MyAccountScreen-module__gap-18___T0LPJ`,
	"gap20": `MyAccountScreen-module__gap-20___zCSX4`,
	"gap24": `MyAccountScreen-module__gap-24___goIVp`,
	"gap26": `MyAccountScreen-module__gap-26___MB0GJ`,
	"gap30": `MyAccountScreen-module__gap-30___TSt_r`,
	"gap32": `MyAccountScreen-module__gap-32___HT5t_`,
	"gap40": `MyAccountScreen-module__gap-40___Ftnqu`,
	"gap50": `MyAccountScreen-module__gap-50___SkUgL`,
	"flex1": `MyAccountScreen-module__flex-1___i1lpm`,
	"flexNone": `MyAccountScreen-module__flex-none___c9cQC`,
	"flexColumn": `MyAccountScreen-module__flex-column___fb7YC`,
	"flexRow": `MyAccountScreen-module__flex-row___Qzzre`,
	"verticallyCentered": `MyAccountScreen-module__vertically-centered___z1_Zf`,
	"horizontallyCentered": `MyAccountScreen-module__horizontally-centered___MgIdt`,
	"horizontallyEnd": `MyAccountScreen-module__horizontally-end___uexvu`,
	"verticallyStart": `MyAccountScreen-module__vertically-start___hNZX1`,
	"spaceBetween": `MyAccountScreen-module__space-between___BsOYl`,
	"flexWrap": `MyAccountScreen-module__flex-wrap___XYAaM`,
	"height100": `MyAccountScreen-module__height-100___xiHXx`,
	"width50": `MyAccountScreen-module__width-50____D7Mn`,
	"width100": `MyAccountScreen-module__width-100___u7jPH`,
	"cursorPointer": `MyAccountScreen-module__cursor-pointer___K1QBq`,
	"cursorNotAllowed": `MyAccountScreen-module__cursor-not-allowed___e_3hU`,
	"absoluteCentered": `MyAccountScreen-module__absolute-centered___Rkj2B`,
	"absolute": `MyAccountScreen-module__absolute___qV_V5`,
	"relative": `MyAccountScreen-module__relative___wr0LP`,
	"fixed": `MyAccountScreen-module__fixed___QM6TY`,
	"visible": `MyAccountScreen-module__visible___zL8JQ`,
	"invisible": `MyAccountScreen-module__invisible___vE7ll`,
	"col90": `MyAccountScreen-module__col-90___RcRTK`,
	"colAuto": `MyAccountScreen-module__col-auto___XOULT`,
	"medicalTabs": `MyAccountScreen-module__medical-tabs___P3rNr`,
	"medicalTableNew": `MyAccountScreen-module__medical-table-new___JGrmN`,
	"noPagination": `MyAccountScreen-module__no-pagination___NmAou`,
	"medicalTableEmpty": `MyAccountScreen-module__medical-table-empty___pKzyf`,
	"iconBtn": `MyAccountScreen-module__icon-btn___oJKuv`,
	"searchIcon": `MyAccountScreen-module__search-icon___hD8_c`,
	"disableSelect": `MyAccountScreen-module__disable-select___usiSx`,
	"breakWord": `MyAccountScreen-module__break-word___HsEwK`,
	"popupClearBtn": `MyAccountScreen-module__popup-clear-btn___aIez2`,
	"scrollMB20": `MyAccountScreen-module__scroll-m-b-20___YqDgC`,
	"container": `MyAccountScreen-module__container___pKKfd`,
	"header": `MyAccountScreen-module__header____uJgU`,
	"title": `MyAccountScreen-module__title___cpShq`,
	"subtitle": `MyAccountScreen-module__subtitle___CJUXR`,
	"avatar": `MyAccountScreen-module__avatar___u297X`,
	"inputRow": `MyAccountScreen-module__inputRow___XJZPg`,
	"input": `MyAccountScreen-module__input___xUe1T`,
	"item": `MyAccountScreen-module__item___BN4rD`,
	"titleContainer": `MyAccountScreen-module__titleContainer___n3vv2`,
	"button": `MyAccountScreen-module__button___uTxrW`
};
module.exports = ___CSS_LOADER_EXPORT___;
